import { render, staticRenderFns } from "./ProjectDepartments.vue?vue&type=template&id=ab13c518&"
import script from "./ProjectDepartments.vue?vue&type=script&lang=js&"
export * from "./ProjectDepartments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports